import React from "react";
import "./style.scss";

interface IncrementInputProps {
    value?: string;
    callback: (value: string) => void;
}

const IncrementInput = ({ value, callback }: IncrementInputProps) => {
    const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
        const inputValue = e.currentTarget.value;
        if (!inputValue || !Number.isNaN(inputValue)) {
            callback(inputValue);
        }
    };

    return (
        <div className="i-input-wrapper">
            <input type="number" value={value} onInput={handleInput} />
        </div>
    );
};

export default IncrementInput;
